// src/stores/initAppData.js
import { create } from "zustand";

/**
 * 유저별 초기 데이터(/ads/select/init/info) 스냅샷
 * - key: user_id
 * - value: 응답 전체 (AdsInitInfoOutPutWithImages)
 * - 절대 수정하지 않는 "초기값 전용" 저장소
 */
const useInitAppDataStore = create((set, get) => ({
  initAppDataMap: {}, // { [user_id]: init_data }

  setInitAppDataOnce: (user_id, init_data) =>
    set((state) => {
      if (!user_id) return state;
      if (state.initAppDataMap[user_id]) {
        // 이미 있으면 그대로 둠 (초기값은 한 번만)
        return state;
      }
      return {
        initAppDataMap: {
          ...state.initAppDataMap,
          [user_id]: init_data,
        },
      };
    }),

  getInitAppData: (user_id) => {
    if (!user_id) return null;
    return get().initAppDataMap[user_id] || null;
  },

  clearInitAppData: () => set({ initAppDataMap: {} }),
}));

export default useInitAppDataStore;
